<!-- AI Generated Template -->
<div class="pages-with-duplicate-title-pages">
    <div class="row">
        <div class="col-48 px-6">
            <page-header header="{{ 'Below you can see a list of all pages that contains the title' | translate }}"
                         headerType="2"
                         panelClass="mb-0">
            </page-header>
        </div>
    </div>
    <table-container [collection]="pages" (onPageChange)="onPageChange($event)" (onPerPageChange)="onPageSizeChange($event)" [progress]="promise">
        <table class="table table-hover table-fixed">
            <thead>
                <tr>
                    <th class="col-24">
                        <span class="inner-l-small" translate>
                            Title and URL
                        </span>
                    </th>
                    <th colspan="3" class="col-24 text-right">
                        &nbsp;
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let page of pages">
                    <td colspan="3" class="text-ellipsis">
                        <div class="inner-l-small">
                            <mon-url-title
                                    *ngIf="!pageDetailsIsAvailable"
                                    [title]="page.title"
                                    [url]="page.url"
                                    [active]="false">
                            </mon-url-title>
                            <url-title-page-details
                                    *ngIf="pageDetailsIsAvailable"
                                    (onClose)="onPageDetailsClose()"
                                    [target]="'page-details-section-seo'"
                                    [subTarget]="issue"
                                    class=""
                                    [page]="page"
                                    [title]="page.title"
                                    [url]="page.url"
                                    [active]="false">
                            </url-title-page-details>
                        </div>
                    </td>
                    <td class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                        <table-page-details ngbTooltip="{{ 'Open page details' | translate }}"
                                            [triggers]="'focus hover'"
                                            [target]="'page-details-section-seo'"
                                            [subTarget]="issue"
                                            [page]="page">
                        </table-page-details>
                        <extension-visual-link-button class="ml-1" [page]="page" [data]="issue" [type]="'seo'"></extension-visual-link-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </table-container>
</div>
